"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import type {StaticImageData} from "next/image";
import type React from "react";
import {useEffect, useState} from "react";
import Container from "@/components/Container";
import {Media} from "@/components/Media";
import RichText from "@/components/RichText";
import type {TwoColumn as TwoColumnProps} from "@/payload-types";
import "./index.scss";
import {CMSLink} from "@/components/Link";
import {cn} from "@/utilities/ui";

type Props = {
	staticImage?: StaticImageData;
} & TwoColumnProps;

const createAnchorId = (row: any) => {
	return `row-${row.id}`;
};

export const TwoColumn: React.FC<Props> = ({
	type,
	order,
	media,
	richText,
	secondText,
	staticImage,
	enableLink,
	link,
	rows,
	sizing,
}) => {
	const [activeAnchor, setActiveAnchor] = useState<string>("");

	useEffect(() => {
		if (!rows || rows.length === 0) return;

		const handleScroll = () => {
			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;
			const viewportHeight = window.innerHeight;
			const headerHeight = 150;
			const triggerPoint = scrollTop + headerHeight + 300;

			let closestElement = "";
			let closestDistance = Infinity;

			for (const row of rows) {
				const anchorId = createAnchorId(row);
				const element = document.getElementById(anchorId);

				if (element) {
					const rect = element.getBoundingClientRect();
					const elementTop = rect.top + scrollTop;
					const elementCenter = elementTop + rect.height / 2;
					const distance = Math.abs(elementCenter - triggerPoint);

					if (
						distance < closestDistance &&
						rect.top < viewportHeight &&
						rect.bottom > 0
					) {
						closestDistance = distance;
						closestElement = anchorId;
					}
				}
			}

			if (closestElement !== activeAnchor) {
				setActiveAnchor(closestElement);
			}
		};

		let timeoutId: NodeJS.Timeout;
		const debouncedScroll = () => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(handleScroll, 10);
		};

		window.addEventListener("scroll", debouncedScroll, { passive: true });
		handleScroll();

		return () => {
			window.removeEventListener("scroll", debouncedScroll);
			clearTimeout(timeoutId);
		};
	}, [rows, activeAnchor]);

	return (
		<div
			className={`two_column_block ${type === "withBorder" ? "border" : ""}`}
		>
			<Container>
				{type === "twoTimesText" && (
					<div className={`two_column text ${order} ${sizing}`}>
						<div className="rich_text">
							{richText && <RichText enableGutter={false} data={richText} />}
							{enableLink && link && <CMSLink {...link} />}
						</div>
						<div className="rich_text">
							{secondText && <RichText enableGutter={false} data={secondText} />}
						</div>
					</div>
				)}
				{type === "textAndImage" && (
					<div className={`two_column image ${order} ${sizing}`}>
						{media && (
							<div className="media">
								{enableLink && link ? (
									<CMSLink {...link} appearance="none" label="">
										<Media src={staticImage} resource={media} />
									</CMSLink>
								) : (
									<Media src={staticImage} resource={media} />
								)}
							</div>
						)}
						<div className="rich_text">
							{richText && <RichText enableGutter={false} data={richText} />}
							{enableLink && link && <CMSLink {...link} />}
						</div>
					</div>
				)}
				{type === "withBorder" && (
					<div className="two_column-wrapper">
						{rows?.map((row) => {
							const anchorId = createAnchorId(row);
							const isActive = activeAnchor === anchorId;

							return (
								<div
									key={row.id}
									id={anchorId}
									className={cn(
										"two_column image border",
										isActive && "active",
									)}
								>
									{row.media && (
										<div className="media">
											<Media src={staticImage} resource={row.media} />
										</div>
									)}
									<div className="rich_text">
										{row.richText && (
											<RichText enableGutter={false} data={row.richText} />
										)}
										{row.enableLink && row.link && <CMSLink {...row.link} />}
									</div>
								</div>
							);
						})}
					</div>
				)}
			</Container>
		</div>
	);
};
